<div class="flex justify-start items-center">
  <button type="button" class="flex mr-16px" (click)="toggleSidebar()">
    <i class="material-icons text-secondary!">menu</i>
  </button>

  <ib-breadcrumbs></ib-breadcrumbs>
</div>

<ib-auth-menu></ib-auth-menu>
